// extracted by mini-css-extract-plugin
module.exports = {"root":"MantineButton_root__vYpe1","inner":"MantineButton_inner__kO1V9","label":"MantineButton_label__5ThIj"};